<template>
  <Row v-if="$can('view', 'performance_dashboard')">
    <i-form>
      <i-form-item label="Reporting Period">
        <DatePicker
          type="daterange"
          v-model="dates"
          format="yyyy-MM-dd"
          style="width: 30%;"
        >
        </DatePicker>
      </i-form-item>
    </i-form>

    <Card> <FactsPerExpert :period="period"> </FactsPerExpert> </Card>
    <Card>
      <ByTerm
        title="Number of facts created by term"
        categoryField="term"
        source="qa_dashboard_nfacts_term"
        :period="period"
      >
      </ByTerm>
    </Card>
    <Card>
      <ByTerm
        title="Number of facts created by role"
        categoryField="event_role"
        source="qa_dashboard_nfacts_role"
        :period="period"
      >
      </ByTerm>
    </Card>
    <Card>
      <ByTerm
        title="Number of facts created by IDU"
        categoryField="idu_status"
        source="qa_dashboard_nfacts_idu"
        :period="period"
      >
      </ByTerm>
    </Card>
    <Card>
      <ByTerm
        title="Number of facts created by review status"
        categoryField="review_status"
        source="qa_dashboard_nfacts_status"
        :period="period"
      >
      </ByTerm>
    </Card>
    <Card>
      <ByTerm
        title="Number of facts created by group"
        categoryField="groups"
        source="qa_dashboard_nfacts_group"
        :period="period"
      >
      </ByTerm>
    </Card>
  </Row>
</template>

<script>
import FactsPerExpert from "./facts-per-expert.vue";
import ByTerm from "./by-term.vue";
import moment from "moment";

export default {
  components: {
    FactsPerExpert,
    ByTerm,
  },
  data() {
    return {
      dates: [],
    };
  },
  created() {
    const start_date = moment()
      .subtract(1, "months")
      .toDate();
    const end_date = moment().toDate();
    this.dates = [start_date, end_date];
    this.dates = [moment("2018-01-01").toDate(), moment("2018-09-01").toDate()];
  },
  computed: {
    period() {
      return [
        moment(this.dates[0]).format("YYYY-MM-DD"),
        moment(this.dates[1]).format("YYYY-MM-DD"),
      ];
    },
  },
};
</script>
